import { Public } from '@mui/icons-material'

const i18nManager = {
  icon: Public,
}

export default i18nManager
